import React from 'react';
import { motion } from 'framer-motion';
import { useApp } from '../context/AppContext';
import { Zap, Sparkles } from 'lucide-react';

export default function ModeToggle() {
  const { mode, toggleMode } = useApp();
  const isCyber = mode === 'cyber';

  return (
    <motion.button
      data-testid="mode-toggle-button"
      onClick={toggleMode}
      whileTap={{ scale: 0.94 }}
      title={isCyber ? 'Switch to StoryBook Land' : 'Switch to Cyber Mode'}
      className={`relative flex items-center gap-2 px-3 py-2 rounded-full font-semibold ${
        isCyber
          ? 'bg-black border border-[#00FFD1]/40 text-[#00FFD1] hover:bg-[#00FFD1]/10 cyber-glow'
          : 'storybook-btn'
      }`}
    >
      {isCyber ? <Zap size={14} /> : <Sparkles size={14} />}
      <span className={`text-xs hidden sm:inline ${isCyber ? 'font-orbitron tracking-widest' : 'font-storybook'}`}>
        {isCyber ? 'CYBER' : 'STORYBOOK'}
      </span>
      <span className={`text-[9px] px-1.5 py-0.5 rounded-full ${isCyber ? 'bg-[#00FFD1] text-black' : 'bg-[#2B5329] text-white'}`}>
        switch
      </span>
    </motion.button>
  );
}
